module.exports = __webpack_public_path__ + "static/media/logo_light.2691acc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_light.svg
// module id = 169
// module chunks = 0